import { DailyBonusModal } from './daily-bonus';
import { useDailyBonus } from '@/contexts/DailyBonusContext';

export const GlobalDailyBonusModal = () => {
  const { showDailyBonusModal, dismissDailyBonusModal } = useDailyBonus();

  return (
    <DailyBonusModal
      isOpen={showDailyBonusModal}
      onClose={dismissDailyBonusModal}
    />
  );
};
